import gql from 'graphql-tag'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'

const query = gql`
  query getRandomLoadingMessage {
    getRandomLoadingMessage
  }
`

const transformer = ({
  getRandomLoadingMessage,
}: {
  getRandomLoadingMessage: string[]
}): string[] => getRandomLoadingMessage

export default queryServiceCreator(query, transformer)
